import React from "react";
import { accompaniment } from "../mock";
import { ArrowRight } from "lucide-react";

export default function Accompaniment() {
  const { eyebrow, title, steps, timeline } = accompaniment;
  return (
    <section id="accompagnement" className="bg-[#EFEAE1] py-20 lg:py-24">
      <div className="mx-auto max-w-[1320px] px-5 lg:px-8">
        <p className="mb-3 flex items-center gap-3 text-[12px] font-semibold uppercase tracking-[0.2em] text-[#B08D57]">
          <span className="h-px w-8 bg-[#B08D57]" /> {eyebrow}
        </p>
        <h2 className="max-w-2xl font-serifDisplay text-[34px] leading-tight text-[#26241F] lg:text-[46px]">
          {title}
        </h2>

        <div className="mt-12 grid gap-10 lg:grid-cols-[1fr_0.9fr] lg:gap-16">
          <div className="space-y-8">
            {steps.map((s) => (
              <div key={s.num} className="flex gap-5">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-[#c9c1b2] text-[14px] font-semibold text-[#B08D57]">
                  {s.num}
                </span>
                <div>
                  <h3 className="text-[19px] font-semibold text-[#26241F]">{s.title}</h3>
                  <p className="mt-2 text-[15px] leading-relaxed text-[#6e6a62]">{s.text}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="relative overflow-hidden rounded-3xl bg-[#26241F] p-8 text-white lg:p-10">
            <div
              className="absolute inset-0 opacity-20"
              style={{
                backgroundImage: `url(${timeline.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#26241F] via-[#26241F]/90 to-[#26241F]/60" />
            <div className="relative">
              <h3 className="font-serifDisplay text-[26px] leading-tight lg:text-[30px]">{timeline.title}</h3>
              <ol className="mt-7 space-y-6">
                {timeline.items.map((item, i) => (
                  <li key={i} className="flex gap-4">
                    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#B08D57] text-[13px] font-bold text-[#26241F]">
                      {i + 1}
                    </span>
                    <div>
                      <div className="text-[16px] font-semibold">{item.title}</div>
                      <div className="mt-1 text-[14px] leading-relaxed text-white/70">{item.text}</div>
                    </div>
                  </li>
                ))}
              </ol>
              <a
                href="#contact"
                className="group mt-8 inline-flex items-center gap-2 text-[14px] font-semibold text-[#B08D57] hover:text-[#c19d63]"
              >
                Découvrir notre service de gestion locative
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
